import { Box, Card, CardContent, Typography } from '@mui/material';
import { AmountField } from './view-contracts-contract-terms-card';
import { combinedTerm } from './view-contracts-contract-terms-container';

interface ViewContractsContractTermsCardProps {
  index: number;
  field: combinedTerm;
  isRejected: boolean;
}

export function ViewContractsDiffingTermsCard({ index, field, isRejected }: ViewContractsContractTermsCardProps) {
  const isValuesSame = Number(field?.currentValue) === field?.againstValue;
  const backgroundColor = isValuesSame
    ? 'transparent'
    : !field?.currentValue
    ? '#ff000040'
    : !field?.againstValue
    ? '#00d8004f'
    : '#fbfb5861';

  return (
    <Card sx={{ backgroundColor }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1, alignItems: 'center' }}>
          <Typography>{field.display}</Typography>
          <AmountField
            selectedTerm={field}
            index={index}
            field={field}
            fieldValue={field.currentValue}
            diffingValue={field?.againstValue}
            isRejected={isRejected}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
